/*
 * @Author: your name
 * @Date: 2020-11-16 11:18:09
 * @LastEditTime: 2021-09-24 16:44:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\assetsManage\api.js
 */
import fetch from '@src/common/lib/axios'
export const api = {
  assetsManage: {
    // 资产管理列表
    // queryAssetsList: 'bms/assets/queryAssetsList.json', //资产条件查询
    queryAssetsList: '/bms/assets/queryAssetsListApi.json', //资产条件查询
    addAssetsInfo: 'bms/assets/addAssetsInfo.json', //资产新增
    updateAssetsInfo: 'bms/assets/updateAssetsInfo.json', //修改资产
    deleteAssetsInfo: 'bms/assets/deleteAssetsInfo.json', //资产删除
    queryAssetsTypeList: 'bms/assets/queryAssetsTypeList.json', //查询资产类型列表
    queryAssetsByType: 'bms/assets/queryAssetsByType.json', //根据资产类型查询该类型的资产信息
    batchFileload: '/common/file/batchFileload.json', // 上传图片
    // 资产领用
    queryAssetsRecipientsList: '/bms/assets/queryAssetsRecipientsList.json', //资产领用查询列表
    addAssetsRecipients: '/bms/assets/addAssetsRecipients.json', //资产领用
    addAssetsReturnedInfo: '/bms/assets/addAssetsReturnedInfo.json', //资产归还
    queryRecTotalNumber: '/bms/assets/queryRecipientsReturnedTotalNumber.json', //根据类型获取领取总数/归还总数
    assetsClaimedDetails: '/bms/assets/assetsClaimedDetails.json', //资产领用详情
    queryReturnedList: '/bms/assets/queryReturnedList.json', //归还记录查询
    queryPersonList: '/vas/personnel/queryPersonListApi.json', //查询人员信息接口
    // 查询不在消防箱内的资产列表
    queryOutHoseboxAssetList (fireassetName, context) {
      const loading = context.$loading({
        lock: true,
        body: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const self = this
      fetch('/bms/assets/queryOutHoseboxAssetList.json', {
        fireassetName,
      }).then((res) => {
        if (res.success) {
          self.queryInHoseboxAssetList(fireassetName, context).then((data) => {
            context.linkAssetsData = [...data, ...res.returnObj] // 左边总数据
            loading.close()
          })
        }
      })
    },
    // 查询在消防箱内的资产列表
    queryInHoseboxAssetList (fireassetName, context) {
      return fetch('/bms/assets/queryInHoseboxAssetList.json', {
        fireassetName,
      }).then((res) => {
        if (res.success) {
          context.linkAssetsModel = res.returnObj.map((v) => v.fireassetName) // 右边选中数据
        }
        return res.returnObj
      })
    },
    updateHoseboxAssetList (context) {
      fetch('/bms/assets/updateHoseboxAssetList.json', {
        fireassetName: context.selectFireassetName,
        fireassetNameList: context.selectLinkAssets,
      }).then((res) => {
        if (res.success) {
          context.$message.success('消防箱资产关联成功!')
          context.linkDialog = false
        } else {
          context.$message.error('消防箱资产关联失败!')
        }
      })
    },
  },
}
